import React from "react";
import "./ReportsNav.less";
import { reportsNavList } from "../../../constants/appConstants";
import { IsSectionVisible } from "../../../utils/helper";

class ReportsNav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultReport: "Health & Safety",
      navLinks: []
    };
  }

  componentDidMount() {
    const navLinks = reportsNavList.filter(x => {
      if (IsSectionVisible(x.id) == true) {
        return x;
      }
      return false;
    });

    this.setState({
      navLinks: navLinks,
      defaultReport: (navLinks[0] || {}).name
    });
    this.props.onNavClick((navLinks[0] || {}).name);
  }

  /** Set active report */
  activeReport = reportTitle => {
    this.setState({ defaultReport: reportTitle });
    this.props.onNavClick(reportTitle);
  };

  render() {
    const WidthStyle = "calc(100%/" + this.state.navLinks.length + ")";
    return (
      <>
        <div className={"reportNav-wrapper"}>
          {(this.state.navLinks || []).map((item, index) => (
            <div
              key={"ReportNavButtons" + index}
              className={
                this.state.defaultReport == item.name
                  ? "nav-element nav-element-active"
                  : "nav-element nav-element-normal"
              }
              style={{ width: WidthStyle }}
              onClick={() => this.activeReport(item.name)}
            >
              {item.name}{" "}
            </div>
          ))}
        </div>
      </>
    );
  }
}

export default ReportsNav;
